// /////////////// IMPORTS //////////////////////// //

import React from 'react';
import { GameWrapper } from '../Styles/Globalstyles';

// /////////////// COMPONENT //////////////////////// //

export const Loader = () => {
  // /////////////// OUTCOME //////////////////////// //
  return (
    <GameWrapper>
      <h1>Loading..</h1>
    </GameWrapper>
  )
}